import { render, staticRenderFns } from "./FourZeroFourComponent.vue?vue&type=template&id=1795fd27&scoped=true&"
import script from "./FourZeroFourComponent.vue?vue&type=script&lang=js&"
export * from "./FourZeroFourComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1795fd27",
  null
  
)

export default component.exports